// WEBDEV-4390: promo copy for the on-page form subtitle, shown only inside
// the window described by GATSBY_ONPAGE_FORM_PROMO.
//
// One GATSBY_-prefixed build-time env var — same inlined-at-build-time
// convention as ON_PAGE_FORM_ENABLED in utils/selfScheduleConfig.js — holding
// a JSON object: { "text": string, "start"?: string, "end": string }.
// "start" is optional: a campaign with no start is live immediately. Set (or
// clear) it per site in the Netlify UI, or per metro in
// packages/<state>/<city>/.env.development for local testing (wrapped in
// single quotes — see docs/local-forms-testing.md).
//
// Both dates must be ISO 8601 with an explicit UTC offset, e.g.
// "2026-10-22T23:59:59-05:00" — matching corporate's equivalent
// GATSBY_FORM_PROMOS (corporate#1327). That's the only date format the JS
// spec guarantees parses identically in every browser; a bare "2026-10-22"
// parses as UTC midnight (shifting the window by hours), and a long-form
// string like "October 22, 2026 23:59:59" parses in each visitor's own local
// timezone (so visitors in different timezones see different effective
// windows) — an explicit offset pins the boundary to the same instant for
// everyone.
//
// Missing, unparseable, or invalid config is treated as "no promo" rather
// than failing the build: this form has exactly one placement, so there's
// nothing for a bad value to silently misconfigure beyond just showing the
// standard subtitle.
//
// The date comparison runs in the visitor's browser on every page load, not
// once at build time, so the copy reverts to the standard subtitle on its own
// once the window ends — no separate takedown deploy needed. That's only
// safe because OnPageSelfScheduleForm never renders at build time today (see
// the comment at its render call site) — if that ever changes, this would
// need corporate's build-time-check-plus-client-timer approach
// (useFormPromoText) instead, to avoid a hydration mismatch.
function parsePromoConfig(raw) {
    if (!raw) return null;

    let config;
    try {
        config = JSON.parse(raw);
    } catch {
        return null;
    }

    if (!config || typeof config.text !== 'string' || !config.text) return null;

    const end = new Date(config.end);
    if (Number.isNaN(end.getTime())) return null;

    const start = config.start ? new Date(config.start) : null;
    if (start && Number.isNaN(start.getTime())) return null;

    return { text: config.text, start, end };
}

const PROMO = parsePromoConfig(process.env.GATSBY_ONPAGE_FORM_PROMO);

function isPromoWindowActive(now) {
    if (!PROMO) return false;
    if (PROMO.start && now < PROMO.start) return false;
    return now <= PROMO.end;
}

// standardSubtitle is the fallback — whatever the caller would otherwise show —
// so a config override still works correctly outside the promo window.
export function getOnPageFormSubtitle(standardSubtitle, now = new Date()) {
    return isPromoWindowActive(now) ? PROMO.text : standardSubtitle;
}
